export default __webpack_public_path__ + "static/img57h-2ad1d94efd23ef2dc6b58feeccece628.jpg";